export default __webpack_public_path__ + "static/media/prize-1.a7398570.webp";